export class UserModel {
    constructor(
        public id: string,
        public name: string,
        public surname: string,
        public email?: string,
        public password?: string,
        public token?: string ,
        public avatar?: any
    ) {}

    public serialize(): any {
        return {
            id: this.id,
            name: this.name,
            surname: this.surname,
            email: this.email,
            password: this.password,
            token: this.token,
            avatar: this.avatar
        };
    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/models/user/user.model.ts